import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceListItemFragment = { readonly __typename?: 'SyncablePriceListItem', readonly id: string, readonly active: boolean, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceListItemPullQueryVariables = Types.Exact<{
  input: Types.PullPriceListItemInput;
}>;


export type SyncPriceListItemPullQuery = { readonly __typename?: 'Query', readonly pullPriceListItem: { readonly __typename?: 'PullPriceListItemResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceListItem', readonly id: string, readonly active: boolean, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceListItemFragmentDoc = gql`
    fragment WholeSyncablePriceListItem on SyncablePriceListItem {
  id
  active
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceListItemPullDocument = gql`
    query SyncPriceListItemPull($input: PullPriceListItemInput!) {
  pullPriceListItem(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceListItem
    }
  }
}
    ${WholeSyncablePriceListItemFragmentDoc}`;

/**
 * __useSyncPriceListItemPullQuery__
 *
 * To run a query within a React component, call `useSyncPriceListItemPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceListItemPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceListItemPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceListItemPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceListItemPullQuery, SyncPriceListItemPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceListItemPullQuery, SyncPriceListItemPullQueryVariables>(SyncPriceListItemPullDocument, options);
      }
export function useSyncPriceListItemPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceListItemPullQuery, SyncPriceListItemPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceListItemPullQuery, SyncPriceListItemPullQueryVariables>(SyncPriceListItemPullDocument, options);
        }
export type SyncPriceListItemPullQueryHookResult = ReturnType<typeof useSyncPriceListItemPullQuery>;
export type SyncPriceListItemPullLazyQueryHookResult = ReturnType<typeof useSyncPriceListItemPullLazyQuery>;
export type SyncPriceListItemPullQueryResult = Apollo.QueryResult<SyncPriceListItemPullQuery, SyncPriceListItemPullQueryVariables>;